import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCREASChartsDataContext } from './hooks/useIDCREASChartsDataContext';

export const HumanResourcesEvolutionChart = () => {
    const { chartData } = useIDCREASChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual de Recursos Humanos"
            subtitles={chartData.humanResources.map((item) => getYearLabel(item.ano))}
            values={chartData.humanResources.map(
                (item) => Number(item.recursos_humanos) || 0
            )}
        />
    );
};
